import { AddToTrolley } from '@sainsburys-tech/bolt'
import noop from 'lodash.noop'
import identity from 'lodash.identity'
import { applyMiddleware, compose, createStore } from 'redux'
import thunkMiddleware from 'redux-thunk'
import createSagaMiddleware, { END } from 'redux-saga'
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'
import { routerMiddleware } from 'connected-react-router'

import analyticsMiddleware from '../middleware/analyticsMiddleware'
import createRootReducer from '../reducers/rootReducer'

const configureStore = (history = null, initialState = {}, allowReduxTools) => {
  const reduxRouterMiddleware = routerMiddleware(history)
  const analyticProps = { onModalClose: noop }
  const devToolsMiddleware = allowReduxTools && reduxImmutableStateInvariant()
  const sagaMiddleware = createSagaMiddleware()
  const addToTrolleyMiddleware = AddToTrolley.callbacksMiddleware(analyticProps)

  const middlewareList = [
    analyticsMiddleware,
    devToolsMiddleware,
    thunkMiddleware,
    sagaMiddleware,
    addToTrolleyMiddleware,
    reduxRouterMiddleware
  ].filter(identity)

  const appliedMiddleware = applyMiddleware(...middlewareList)
  const middleware = compose(
    appliedMiddleware,
    typeof window === 'object' && typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : callback => callback
  )
  const store = createStore(createRootReducer(history), initialState, middleware)

  store.runSaga = sagaMiddleware.run
  store.close = () => store.dispatch(END)

  return store
}

export default configureStore
